/** @jsxImportSource @emotion/react */

import { css } from "@emotion/react";
import { PALETTE } from "styles/base/variables";

interface BaseCheckProps extends React.InputHTMLAttributes<HTMLInputElement> {
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label?: string;
  color?: string;
}

function BaseCheck({
  checked,
  onChange,
  label,
  color = PALETTE.primary,
  ...rest
}: BaseCheckProps) {
  return (
    <label>
      <input
        css={css`
          width: 17px;
          height: 17px;
          accent-color: ${PALETTE.primary};
        `}
        type="checkbox"
        checked={checked}
        onChange={onChange}
        {...rest}
      />
      {label && label}
    </label>
  );
}

export default BaseCheck;
